import React from 'react';
import HotSeatEmptyContent from '../hotseat/HotSeatEmptyContent';
import stageImage from '../../assets/virtual-raffle/loading-stage.webp';

export default function RaffleEmptyContent({ onRestart, onBack }) {
  return <div style={{ position: 'absolute', inset: 0, background: `linear-gradient(#0b080cbb, #0b080cee), url(${stageImage}) center / cover` }}>
    <HotSeatEmptyContent onRetry={onRestart} onBack={onBack} retryLabel="REINICIAR"
      description="Este sorteo finalizó sin un cupón ganador." />
  </div>;
}
